export const SECONDARY_MKT_QUOTATION_TYPE_ITEMS = [
  { id: 'CLEAN', displayValue: 'Clean' },
  { id: 'DIRTY', displayValue: 'Dirty' },
];
